<template>
  <div class="free-staking">
    <China></China>
  </div>
</template>
<script>
import China from './china.vue';

export default {
  components: {
    China,
  },
};
</script>
<style lang="stylus" scoped>

</style>
